<template>
  <div>
    <topbar :title="$t('maps.page-title')" @back="$router.push({name: 'Maps'})" :showBack="true" />

    <template v-if="!loading || true">

      <div class="p-3 mx-auto max-w-3xl w-full md:px-3 xl:max-w-none xl:three-columns xl:grid">
        <div class="xl:col-start-2">

          <div class="space-x-2 justify-items-stretch flex xl:hidden">
            <check-button class="flex-1" radio="one" :showCheck="false" v-model="oneOrAll">una variante</check-button>
            <check-button class="flex-1" radio="all" :showCheck="false" v-model="oneOrAll">tutte le varianti</check-button>
          </div>

          <card type="square" class="rounded-lg">

            <dropdown class="hidden xl:block" innerlabel="Visualizzazione" :outerlabel="oneOrAll === 'one' ? 'Mappa' : 'Grafico'" :enabled="true" ref="oneOrAllDropdown">
              <a
                class="border-t border-line p-3 block"
                @click="oneOrAll = 'one'"
                v-if="oneOrAll === 'all'"
              >Mappa</a>
              <a
                class="border-t border-line p-3 block"
                @click="oneOrAll = 'all'"
                v-if="oneOrAll === 'one'"
              >Grafico</a>
            </dropdown>
            
            <template v-if="oneOrAll === 'one'">
              <dropdown :outerlabel="showAll ? 'Tutte le varianti' : currentWord" innerlabel="Varianti" ref="variants" :enabled="createdVariants.length > 0">
                <a
                  class="border-t border-line p-3 block"
                  v-for="variant of createdVariants"
                  @click="currentWord = variant"
                  :key="`vars-${variant}`"
                >{{variant}}</a>

                <a 
                  v-if="!showAll && createdVariants.length > 0"
                  class="border-t border-line p-3 hidden xl:block w-full focus:outline-none"
                  @click="currentWord = null"
                  :key="`vars----`"
                >Tutte le varianti</a>

              </dropdown>

              <div v-if="url" class="xl:flex">
                <div class="aspect-ratio-16/9 relative xl:w-3/4">
                  <div class="absolute top-0 left-0 w-full h-full overflow-hidden rounded-bl-lg">
                    <wordmap :gsurl="url" @loaded="loadeddata = $event" />
                  </div>
                </div>
                <div class="xl:w-1/4" v-if="Array.isArray(url) && url.length === 1">
                  <wordlocations :gsurl="url[0]" />
                </div>
                <div class="xl:w-1/4" v-else-if="Array.isArray(url) && url.length >= 1 && loadeddata.length === url.length">
                  <div v-for="(v, i) of createdVariants" :key="i" class="flex items-center">
                    <div class="flex-shrink-0 p-2">
                      <div class="rounded-full w-12 h-12 relative" :style="{backgroundColor: colors[i]}"></div>
                    </div>
                    <div class="w-full flex flex-col">
                      <div>{{v}}</div>
                      <div class="relative h-3">
                        <div class="absolute top-0 left-0 h-full bg-gray-500" :style="{width: 100 * loadeddata[i].total / voteTotal + '%'}"></div>
                      </div>
                    </div>
                    <div class="flex-shrink-0 p-2">
                      <span class="text-5xl">{{Math.round(100 * loadeddata[i].total / voteTotal)}}</span><span>%</span>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div v-else class="overflow-hidden">
                <div class="aspect-ratio-16/9 relative">
                  <div class="absolute top-0 left-0 w-full h-full overflow-hidden">
                    <wordmap />
                  </div>
                </div>
                <div class="m-2">
                  Che velocità!<br>
                  La mappa deve ancora essere aggiornata.<br>
                  Torna più tardi
                </div>
              </div>
            </template>

            <template v-else>
              <variant-stats :word="word" :colors="colors" />
            </template>
          </card>
        </div>

      </div>
    </template>

  </div>
</template>

<script>
import Wordmap from "@/components/maps/Wordmap";
import Wordlocations from '@/components/maps/Wordlocations';
import { mapActions, mapGetters } from "vuex";
import CheckButton from '@/components/CheckButton.vue';
import VariantStats from '@/components/maps/VariantStats.vue';

export default {
  components: {
    Wordmap,
    Wordlocations,
    CheckButton,
    VariantStats
  },

  data() {
    return {
      loading: true,
      currentWord: this.$route.params.id,
      wordId: this.$route.params.id,
      loadeddata: [],
      colors: [ '#00A59C', '#FFBE45', '#A31DB5', '#FC6F73', '#4053D0' ],
      oneOrAll: 'one'
    }
  },

  mounted() {
    const id = this.$route.params.id
    if(id) {
      this.visitWord(id)
    }
  },

  watch: {
    $route(to) {
      if(to.name === 'MapsDetail') {
        this.currentWord = to.params.id;
        this.wordId = to.params.id;
        this.visitWord(to.params.id)
      }
    },
    currentWord(newid, oldid) {
      if(newid != oldid) {
        this.$refs.variants.close()
      }
    },
    oneOrAll() {
      this.$refs.oneOrAllDropdown.close()
    }
  },

  methods: mapActions("surveys", ["visitWord"]),

  computed: {
    ...mapGetters("surveys", ["words"]),
    ...mapGetters("wordmaps", ["mapUrls"]),
    
    
    showAll() {
      return this.currentWord === null
    },

    word() {
      if (this.words) {
        const id = this.currentWord || this.wordId

        for (const word of this.words) {
          if(word.word === id) {
            return word
          } else if(word.variants.includes(id)) {
            return {
              word: id, 
              visited: true,
              variants: [word.word, ...word.variants.filter(w => w !== id)]
            }
          }
        }
      }
      return null;
    },

    url() {
      if(this.mapUrls && this.word) {
        if(this.showAll) {
          return this.createdVariants.map(w => this.mapUrls[w])
        } else {
          return [this.mapUrls[this.currentWord]];
        }
      }
      return null;
    },

    voteTotal() {
      let total = 0
      for (const v of this.loadeddata) {
        total += v.total
      }
      return total
    },

    createdVariants() {
      if(this.word && this.mapUrls) {
        if(this.showAll) {
          return [this.word.word, ...this.word.variants.filter(v => v in this.mapUrls)]
        } else {
          return this.word.variants.filter(v => v in this.mapUrls)
        }
      }
      return []
    },
  },
};
</script>

<style>
</style>